module.exports = __webpack_public_path__ + "static/media/face-with-tongue-svgrepo-com.0cad9452.svg";